<popup-header [dialogRef]="dialogRef" icon="help_outline" [text]="'Create Program'"></popup-header>
<div class="program-type-dialog">
  <p>Do you want to create a multi products program or a single product program ?</p>
  <div class="type-buttons">
    <button class="btn btn-secondary" (click)="selectType('multi')">
      Multi Products
    </button>
    <button class="btn btn-primary" (click)="selectType('single')">
      Single Product
    </button>
  </div>
</div>
